import { Routes, Route, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

// import all page here

import Login from './Componets/Login';
import ForgotPassword from './controllers/ForgotPassword';
import Resetpassword from './controllers/Resetpassword';

import Error from './Componets/Error';
import Home from './SuparAdmin/Home';
import ViewClient from './SuparAdmin/ViewClient';
import ViewAdmins from './SuparAdmin/ViewAdmins';
import AddClients from './SuparAdmin/AddClients';
import AddAdmins from './SuparAdmin/AddAdmins';
import Account from './SuparAdmin/Account';
import EditClinet from './SuparAdmin/EditClinet';
import EditAdmin from './SuparAdmin/EditAdmin';

import AdminHome from './Admin/AdminHome';
import ListFaculty from './Admin/ListFaculty';
import AddFaculty from './Admin/AddFaculty';
import EditFaculty from './Admin/EditFaculty';
import AddExam from './Admin/AddExam';
import ListExam from './Admin/ListExam';
import AddSubject from './Admin/AddSubject';
import ListSubject from './Admin/ListSubject';
import EditSubject from './Admin/EditSubject';
import EditExam from './Admin/EditExam';
import ExamDetails from './Admin/ExamDetails';
import ExamSetting from './Admin/setting/ExamSetting';
import ListSection from './Admin/ListSection';
import AddSection from './Admin/AddSection';
import EditSection from './Admin/EditSection';
import AnswerSheetDetails from './Admin/AnswerSheetDetails';
import AllocationDetails from './Admin/AllocationDetails';
import SheetTransfer from './Admin/SheetTransfer';
import Result from './Admin/Result';
import ListStudentDetails from './StudentDetails/ListStudentDetails';
import AddStudentDetails from './StudentDetails/AddStudentDetails';
import EditStudentDetails from './StudentDetails/EditStudentDetails';
import StudentDasboard from './StudentDetails/StudentDasboard';
import InternalDasboard from './InternalMarks/InternalDasboard';
import SubjectList from './InternalMarks/SubjectList';
import ListMarks from './InternalMarks/ListMarks';
import AddInternalmarks from './InternalMarks/AddInternalmarks';
import EditInternalMarks from './InternalMarks/EditInternalMarks';
import ResultDasboard from './ManageResult/ResultDasboard';
import EmergencyBarcode from './Admin/barcode Generator/EmergencyBarcode';
import WithBarcode from './Admin/barcode Generator/WithBarcode';
import WithoutBarcode from './Admin/barcode Generator/WithoutBarcode';
import ListResult from './ManageResult/ListResult';
import ReasseDasboard from './Reassessment/ReasseDasboard';
import ReasseSubjectList from './Reassessment/ReasseSubjectList';
import AddReassessment from './Reassessment/AddReassessment';
import Details from './Admin/Bank Details/Details';
import ReassResult from './ManageResult/ReassResult';
import RejectdDasboard from './RejectedSheet/RejectdDasboard';
import RejectedSubjectList from './RejectedSheet/RejectedSubjectList';

import ReportDashbord from './Report/ReportDashbord';
import Report from './Report/Report';
import ReportExam from './Report/ReportExam';
import ReportData from './Report/BarcodeReport';
import Chart from './Report/Chart';

import UserHome from './Faculty/UserHome';
import AnswerSheet from './Faculty/AnswerSheet';
import ViewAnswerSheet from './Faculty/ViewAnswerSheet';
import AllocateSheets from './Faculty/AllocateSheets';
import ReassExams from './Faculty/ReassExams';
import ReassAllocate from './Faculty/ReassAllocate';
import Setting from './Admin/setting/Setting';
import Profile from './Faculty/Profile/Profile';
import ReReassessmen from './Reassessment/ReReassessmen';
import Sheet from './RejectedSheet/Sheet';

// loggin History
import AdminHistory from './Admin/History/HistoryLIst';
import SuparAdminHistory from './SuparAdmin/History/HistoryLIst';
import FacityHistory from './Faculty/History/HistoryLIst';

// Manual Markes
import ManualMarkExam from './ManualMarke/Exam';
import ManualMarkSubject from './ManualMarke/SubjectList';
import ManualMarkList from './ManualMarke/ListMarks';
import ReassMarks from './ManualMarke/ReassMarks';

// Omr Markes
import OmrMarkExam from './OmrMarks/Exam';
import OmrMarkSubject from './OmrMarks/SubjectList';
import OmrMarkList from './OmrMarks/ListMarks';

// ProgramObjective
import ProgramObjectiveAdd from './ProgramObjective/Add';
import ProgramObjectiveList from './ProgramObjective/List';
import ProgramObjectiveEdit from './ProgramObjective/Edit';

// Program
import ProgramAdd from './ProgramObjective/Programs/Add';
import ProgramList from './ProgramObjective/Programs/List';
import ProgramEdit from './ProgramObjective/Programs/Edit';

// Objective
import ObjectiveAdd from './ProgramObjective/Objectives/Add';
import ObjectiveList from './ProgramObjective/Objectives/List';
import ObjectiveEdit from './ProgramObjective/Objectives/Edit';

function App() {
  const [loggin, setloggin] = useState(true);
  const navigate = useNavigate();

  const cheackloginActivity = () => {
    const expireTime = localStorage.getItem('expireTime');
    if (expireTime < Date.now()) {
      console.log('logout');
      setloggin(false);
      localStorage.clear();
      navigate('/');
    }
  };

  const updateExpireTime = () => {
    // Get the expiration time from an environment variable or default to 15 minutes
    const expirationMinutes = process.env.REACT_APP_EXPIRE_MINUTES;
    const expireTime = Date.now() + expirationMinutes * 60 * 1000;
    localStorage.setItem('expireTime', expireTime);
  };

  useEffect(() => {
    const interval = setInterval(cheackloginActivity, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    updateExpireTime();
    window.addEventListener('mousemove', updateExpireTime);
    window.addEventListener('keydown', updateExpireTime);
    window.addEventListener('scroll', updateExpireTime);
    window.addEventListener('click', updateExpireTime);

    return () => {
      window.removeEventListener('mousemove', updateExpireTime);
      window.removeEventListener('keydown', updateExpireTime);
      window.removeEventListener('scroll', updateExpireTime);
      window.removeEventListener('click', updateExpireTime);
    };
  }, []);

  return (
    <>
      {/* routes set to all page here */}
      <Routes>
        {/* common pages */}
        <Route path="/" element={<Login />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/resetpassword" element={<Resetpassword />} />

        <Route path="/*" element={<Error />} />
        {/* Super Admin */}
        {loggin.toString()}
        <Route path="/Home" element={<Home />} />
        <Route path="/ViewClient" element={<ViewClient />} />
        <Route path="/ViewAdmins" element={<ViewAdmins />} />
        <Route path="/AddClients" element={<AddClients />} />
        <Route path="/AddAdmins" element={<AddAdmins />} />
        <Route path="/Account" element={<Account />} />
        <Route path="/EditClinet" element={<EditClinet />} />
        <Route path="/EditAdmin" element={<EditAdmin />} />
        {/* Admin */}
        <Route path="/AdminHome" element={<AdminHome />} />
        <Route path="/ListFaculty" element={<ListFaculty />} />
        <Route path="/AddFaculty" element={<AddFaculty />} />
        <Route path="/EditFaculty" element={<EditFaculty />} />
        <Route path="/AddExam" element={<AddExam />} />
        <Route path="/ListExam" element={<ListExam />} />
        <Route path="/AddSubject" element={<AddSubject />} />
        <Route path="/ListSubject" element={<ListSubject />} />
        <Route path="/EditSubject" element={<EditSubject />} />
        <Route path="/EditExam" element={<EditExam />} />
        <Route path="/ExamDetails" element={<ExamDetails />} />
        <Route path="/examsetting" element={<ExamSetting />} />

        <Route path="/AddSection" element={<AddSection />} />
        <Route path="/ListSection" element={<ListSection />} />
        <Route path="/EditSection" element={<EditSection />} />
        <Route path="/AnswerSheetDetails" element={<AnswerSheetDetails />} />
        <Route path="/AllocationDetails" element={<AllocationDetails />} />
        <Route path="/sheetTransfer" element={<SheetTransfer />} />
        <Route path="/Result" element={<Result />} />
        {/* Student Details */}
        <Route path="/StudentDetails" element={<ListStudentDetails />} />
        <Route path="/EditStudentDetails" element={<EditStudentDetails />} />
        <Route path="/AddStudentDetails" element={<AddStudentDetails />} />
        <Route path="/StudentDasboard" element={<StudentDasboard />} />
        {/* Internal Marks */}
        <Route path="/InternalDasboard" element={<InternalDasboard />} />
        <Route path="/SubjectList" element={<SubjectList />} />
        <Route path="/ListMarks" element={<ListMarks />} />
        <Route path="/AddInternalmarks" element={<AddInternalmarks />} />
        <Route path="/EditInternalMarks" element={<EditInternalMarks />} />

        {/* Barcode */}
        <Route path="/EmergencyBarcode" element={<EmergencyBarcode />} />
        <Route path="/WithBarcode" element={<WithBarcode />} />
        <Route path="/WithoutBarcode" element={<WithoutBarcode />} />

        {/* bank details */}
        <Route path="/Details" element={<Details />} />

        {/* Manage Result */}
        <Route path="/ResultDasboard" element={<ResultDasboard />} />
        <Route path="/ListResult" element={<ListResult />} />

        {/* Manage Reassessment */}
        <Route path="/ReasseDasboard" element={<ReasseDasboard />} />
        <Route path="/ReasseSubjectList" element={<ReasseSubjectList />} />
        <Route path="/AddReassessment" element={<AddReassessment />} />
        <Route path="/ReReassessmen" element={<ReReassessmen />} />
        <Route path="/ReassResult" element={<ReassResult />} />
        {/* Rejected sheet */}
        <Route path="/Rejectedsheet" element={<Sheet />} />
        <Route path="/RejectedDasboard" element={<RejectdDasboard />} />
        <Route path="/RejectedSubjectList" element={<RejectedSubjectList />} />

        {/* Report */}
        <Route path="/ReportDashbord" element={<ReportDashbord />} />
        <Route path="/ReportExam" element={<ReportExam />} />
        <Route path="/Report" element={<Report />} />
        <Route path="/ReportData" element={<ReportData />} />
        <Route path="/Chart" element={<Chart />} />

        {/* Faculty */}

        <Route path="/UserHome" element={<UserHome />} />
        <Route path="/AnswerSheet" element={<AnswerSheet />} />
        <Route path="/ViewAnswerSheet" element={<ViewAnswerSheet />} />
        <Route path="/AllocateSheets" element={<AllocateSheets />} />
        <Route path="/ReassExams" element={<ReassExams />} />
        <Route path="/ReassAllocate" element={<ReassAllocate />} />
        <Route path="/Setting" element={<Setting />} />
        <Route path="/Profile" element={<Profile />} />

        {/* loggin History */}
        <Route path="/AdminHistory" element={<AdminHistory />} />
        <Route path="/SuparAdminHistory" element={<SuparAdminHistory />} />
        <Route path="/FacityHistory" element={<FacityHistory />} />

        {/* Manual Markes */}
        <Route path="/menualmarkexam" element={<ManualMarkExam />} />
        <Route path="/menualmarksubject" element={<ManualMarkSubject />} />
        <Route path="/menualmarklist" element={<ManualMarkList />} />
        <Route path="/reassmarks" element={<ReassMarks />} />

        {/* OMR Marks */}
        <Route path="/omrmarkexam" element={<OmrMarkExam />} />
        <Route path="/omrmarksubject" element={<OmrMarkSubject />} />
        <Route path="/omrmarklist" element={<OmrMarkList />} />

        {/* Program Objective */}
        <Route path="/ProgramObjectiveAdd" element={<ProgramObjectiveAdd />} />
        <Route
          path="/ProgramObjectiveList"
          element={<ProgramObjectiveList />}
        />
        <Route
          path="/ProgramObjectiveEdit"
          element={<ProgramObjectiveEdit />}
        />

        {/* Program */}
        <Route path="/ProgramAdd" element={<ProgramAdd />} />
        <Route path="/ProgramList" element={<ProgramList />} />
        <Route path="/ProgramEdit" element={<ProgramEdit />} />

        {/* Objective */}
        <Route path="/ObjectiveAdd" element={<ObjectiveAdd />} />
        <Route path="/ObjectiveList" element={<ObjectiveList />} />
        <Route path="/ObjectiveEdit" element={<ObjectiveEdit />} />
      </Routes>
    </>
  );
}

export default App;
